// ClearCurve Logo - Active Production Logo
// Concept: Tight Lockup (Focus Icon + Bold/Thin Text)

import React from "react";
import ClearCurveFinal from "./logos/ClearCurve_Final";

interface LogoProps {
  variant?: "full" | "icon";
  size?: "sm" | "md" | "lg";
  className?: string;
}

export default function Logo({ variant = "full", size = "md", className = "" }: LogoProps) {
  return (
    <ClearCurveFinal variant={variant} size={size} className={className} />
  );
}
